import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import RequestReviewPage from "./pages/RequestReviewPage";
import CustomQuotePage from "./pages/CustomQuotePage";
import PolicyPage from "./pages/PolicyPage";
import SuccessPage from "./pages/SuccessPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/request-review" element={<RequestReviewPage />} />
          <Route path="/custom-quote" element={<CustomQuotePage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/privacy-policy" element={<PolicyPage />} />
          <Route path="/terms-of-service" element={<PolicyPage />} />
          <Route path="/refund-policy" element={<PolicyPage />} />
          <Route path="/cancellation-policy" element={<PolicyPage />} />
          <Route path="/delivery-policy" element={<PolicyPage />} />
          <Route path="/legal-notice" element={<PolicyPage />} />
          <Route path="/cookie-policy" element={<PolicyPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
